module.exports = __webpack_public_path__ + "img/news.2eab3822.jpg";